import React from 'react';
import R from 'ramda';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { HeroFullCombined } from '@cotyorg/ccx-organism-hero';
import { getPages } from '@cotyorg/ccx-organism-cards/helpers/pagination';
import OptionalSection from '@cotyorg/ccx-utils/js/components/OptionalSection';
import CategoryBanner from '../../molecules/CategoryBanner';
import StandardLayout from '../../templates/StandardLayout';

const getCardsProps = (page) => ({
  cardsData: page.map((card) => ({
    ...card,
    contentBoxAlignment: 'bottom',
  })),
  key: page.reduce((key, card) => `${key}${card.id}`, ''),
  isTitleUnderlined: false,
  headingLevel: 3,
});

const OurBrandComponent = ({
  categoryBanner,
  currentBreakpoint,
  stories,
  hero,
}) => (
  <StandardLayout>
    <CategoryBanner
      heading={R.prop('heading')(categoryBanner)}
      text={R.prop('text')(categoryBanner)}
    />

    <div className="our-brand--hero-wrapper">
      <div className="grid-container container-no-gutters">
        <HeroFullCombined
          heroStoreDataKey="maxFactorStory"
          isUnderlined={false}
          theme="dark"
        />
      </div>
    </div>

    <div className="our-brand__cards">
      {getPages({
        currentBreakpoint,
        cardsData: stories,
        getCardsProps,
        cardsPerPageMap: {
          xsmall: 1,
          small: 1,
          medium: 2,
          large: 2,
          xlarge: 2,
        },
      })}
    </div>

    <OptionalSection
      renderCondition={!!R.prop('iconicLooks', hero)}
      section={() => (
        <div className="our-brand--hero-wrapper">
          <div className="grid-container container-no-gutters">
            <HeroFullCombined
              heroStoreDataKey="iconicLooks"
              isUnderlined={false}
              isContentFirst
              theme="light"
            />
          </div>
        </div>
      )}
    />
  </StandardLayout>
);

OurBrandComponent.propTypes = {
  categoryBanner: PropTypes.shape({
    heading: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  }).isRequired,
  currentBreakpoint: PropTypes.string,
  stories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      heading: PropTypes.string,
      description: PropTypes.description,
      imageSrc: PropTypes.string,
      imageSrcSet: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          src: PropTypes.string,
        })
      ),
      link: PropTypes.shape({
        text: PropTypes.string,
        url: PropTypes.string,
      }),
    })
  ),
  hero: PropTypes.instanceOf(PropTypes.object),
};

export default connect(({ content, breakpoints }) => ({
  categoryBanner: R.prop('categoryBanner')(content),
  currentBreakpoint: R.prop('current')(breakpoints),
  stories: R.path(['cards', 'stories'])(content),
  hero: R.prop('hero', content),
}))(OurBrandComponent);
